<template>
  <div class="linksList">
    <v-list-item
      v-for="link in links"
      :v-show="link.uri"
      :key="`${link.uri}${Math.random()}`"
      :class="[getColor(link.style), 'listStyle']"
      @click="onLinkClick(link)"
    >
      <v-list-item-content>
        <v-list-item-title :class="[getColor(link.style)]">
          <b :style="styles">{{ link.label || 'Link' }}</b>
        </v-list-item-title>
      </v-list-item-content>

      <v-list-item-action>
        <v-icon style="color:white">mdi-chevron-right</v-icon>
      </v-list-item-action>
    </v-list-item>
  </div>
</template>

<script>
import { getValidStyle, convertEmToPixels } from '@/helper/helper'
import { openLink } from '@/utils/ReactNative'
import { RegisterEvent } from '@/analytics'

export default {
  name: 'Links',
  props: {
    links: Array
  },
  computed: {
    styles () {
      const result = convertEmToPixels(16)
      return {
        'font-size': result + 'px',
        'line-height': `${result + 2}px`
      }
    }
  },
  methods: {
    onPostLike (link) {
      return link.uri
    },
    getColor (style) {
      return getValidStyle(style)
    },
    onLinkClick (link) {
      openLink(link)
      RegisterEvent('chi_url_open', { target_id: link.uri, target_key: 'link' })
    }
  },
  data: () => ({})
}
</script>



// WEBPACK FOOTER //
// src/components/publication/links.vue